// extracted by mini-css-extract-plugin
export default {"container":"doc_2uqQH","icon":"doc_ico_9Db7S","blockedIcon":"doc_blo_3HxRF","typeIcon":"doc_typ_2nVqC","brandIcon":"doc_bra_Ua3yM","progress":"doc_pro_1bz8b"};